import { render, staticRenderFns } from "./GestioneAttivitaTasksDettaglioPage.vue?vue&type=template&id=697e8892"
import script from "./GestioneAttivitaTasksDettaglioPage.vue?vue&type=script&lang=js"
export * from "./GestioneAttivitaTasksDettaglioPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports